import { type FC } from "react";

import { Button } from "@snapchat/snap-design-system";

import { TosModalAccept, TosModalDismiss } from "../messages.generated";

import { StepIndicator } from "./StepIndicator";
import styles from "./TosModalFooter.module.css";

interface TosModalFooterProps {
    isMultiStep: boolean;
    totalSteps: number;
    currentStep: number;
    completedSteps: Set<number>;
    accepted: boolean;
    loading: boolean;
    disabled: boolean;
    isLastStep: boolean;
    isCurrentStepCompleted: boolean;
    onStepClick: (stepIndex: number) => void;
    onNext: () => Promise<void>;
    onDismiss: () => void;
}

export const TosModalFooter: FC<TosModalFooterProps> = ({
    isMultiStep,
    totalSteps,
    currentStep,
    completedSteps,
    accepted,
    loading,
    disabled,
    isLastStep,
    isCurrentStepCompleted,
    onStepClick,
    onNext,
    onDismiss,
}) => {
    const isActionDisabled = disabled || (!isCurrentStepCompleted && !accepted);
    const actionButtonHandler = accepted ? undefined : onNext;

    return (
        <div className={styles.customFooter}>
            <div>
                {isMultiStep && (
                    <div className={styles.stepperContainer}>
                        {Array.from({ length: totalSteps }, (_, index) => (
                            <StepIndicator
                                key={index}
                                stepIndex={index}
                                totalSteps={totalSteps}
                                currentStep={currentStep}
                                completedSteps={completedSteps}
                                accepted={accepted}
                                onStepClick={onStepClick}
                            />
                        ))}
                    </div>
                )}
            </div>
            <div className={styles.footerButtons}>
                <Button onClick={onDismiss} isDisabled={loading}>
                    <TosModalDismiss />
                </Button>
                {!accepted && (
                    <Button
                        type="primary"
                        onClick={actionButtonHandler}
                        isDisabled={isActionDisabled}
                        isPending={loading}
                    >
                        {isLastStep ? <TosModalAccept /> : "Accept & Next"}
                    </Button>
                )}
            </div>
        </div>
    );
};
